module.exports = __webpack_public_path__ + "static/media/restoran-gril-2.1378c314.jpg";